import $ from "jquery";

// import popper from "popper.js";
import { bootstrap } from "bootstrap";
// import lightbox from "lightbox2";
// import slick from "slick-carousel";
// import datepicker from "air-datepicker";
import bootstrapSelect from "bootstrap-select/dist/js/bootstrap-select.min.js";
// import e from "express";

// import "jquery-validation";
// import "jquery-validation/dist/additional-methods.js"
$( document ).ready(function () {
  // Show Password/Hide Password
  $('.js-toogleVisibility').on('click', function () {
    let input = $(this).closest('.form-group').find('input');

    if (input.attr('type') == 'text') {
      input.attr('type', 'password');
      $(this).addClass('Icon--showPass').removeClass('Icon--hidePass');
    } else if (input.attr('type') == 'password') {
      input.attr('type', 'text') == 'text';
      $(this).addClass('Icon--hidePass').removeClass('Icon--showPass');
    }
  });

  $("#mobile-menu-btn").click( function () {
    if($("#mobile-drop-menu").hasClass("opened")) {
      $("#mobile-drop-menu").removeClass("opened");
    } else {
      $("#mobile-drop-menu").addClass("opened");
    }
  });
});

// $( document ).ready(function () {

//   $('[data-toggle="popover"]').popover();
  
//   if ($(".selectpicker").length) {
//     $('.selectpicker').each(function () {
//       $(this).selectpicker({
//         noneSelectedText: $(this).data('placeholder') || 'Nothing selected'
//       });
//     });
//   }

//   if( $("#carouselBanner").length ){
//     $("#carouselBanner").slick({autoplay:true,arrows:false,variableWidth:false  });
//   }

  
//   if( $("#f4f-videos-slider").length ){
//     $("#f4f-videos-slider").slick({
//       autoplay: false,
//       arrows: true,
//       variableWidth: false,
//       slidesToShow: 3,
//       infinite: false,
//       responsive: [
//         {
//           breakpoint: 767,
//           settings: {
//             slidesToShow: 1,
//           }
//         }
//       ] 
//     });
//   }

//   window.onscroll = function() {myFunction()};

//   const scrollToTheTop = function () {
//     $([document.documentElement, document.body]).animate({
//       scrollTop: $("body").offset().top
//     }, 300);
//   }

//   // Get the header
//   var $header = $("#stickyHeader");
//   var $headerMobile = $("#stickyHeaderMobile");

//   // Get the offset position of the navbar
//   var sticky = $header.offset().top;
//   var stickyMobile = $headerMobile.offset().top;

//   // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
//   function myFunction() {
//     if (window.pageYOffset > sticky) {
//       $header.addClass("sticky");
//       $(".f4f-sticky-header-wrapper").css({minHeight: $header.outerHeight()});
//     } else {
//       $header.removeClass("sticky");
//     }
//     if (window.pageYOffset > stickyMobile) {
//       $headerMobile.addClass("sticky");
//       $(".f4f-sticky-mobile-header-wrapper").css({minHeight: $headerMobile.outerHeight()});
//     } else {
//       $headerMobile.removeClass("sticky");
//     }
//   }

//   $(window).resize(function() {
//     $(".f4f-sticky-header-wrapper").css({minHeight: $header.outerHeight()});
//     $(".f4f-sticky-mobile-header-wrapper").css({minHeight: $headerMobile.outerHeight()});
//     if ($(".f4f-hero-background-wrap").length) {
//       $(".f4f-container-with-hero-on-top").css({paddingTop: $(".f4f-hero-background-wrap").height() - $('.f4f-header').outerHeight()});
//     }
//   });

//   $(window).on("load", function() {
//     $(window).resize();
//   });

//   $('#trigger-overlay').on('click', function(){
//     if ($(this).hasClass('open')) {
//       $(".f4f-overlay").removeClass('open');
//       $(".f4f-mobile-menu-burger").removeClass("open");
//     } else {
//       $(".f4f-overlay").addClass('open');
//       $(".f4f-mobile-menu-burger").addClass("open");
//       $("#carouselBanner-mobile").slick({autoplay:true,arrows:false,variableWidth:false });
//     }
//   });

//   $('.f4f-header').each(function(){
//       // var $bgobj = $(this); // создаем объект
//       var $overlay = $('.f4f-image-dark-overlay');
//       $(window).scroll(function() {
//           // var yPos = -($(window).scrollTop() / $bgobj.data('speed')); // вычисляем коэффициент 
//           // Присваиваем значение background-position
//           // var coords = 'center '+ yPos + 'px';
//           var opacity = $(window).scrollTop() / 800;
//           $overlay.css({opacity: opacity < 0.8 ? opacity : 0.8});
//           // Создаем эффект Parallax Scrolling
//           // $bgobj.css({ backgroundPosition: coords });
//       });
//   });

//   $('.f4f-mobile-news-filters-btn').click(function () {
//     $('.f4f-news-filters-wrapper').toggleClass('show');
//   });

//   // --------------------- Modal Demo Scripts (TODO, change or remove these scripts after implementing back-end part ---------------------
//   $('.js-demoConfirmDeleteProfile').on('click', function (e) {
//     e.preventDefault();
//     $('.js-demoConfirmDeleteProfileWindow').modal('show');
//   })

//   $('.js-demoEditProfile').on('click', function (e) {
//     e.preventDefault();
//     $('.js-demoEditProfileWindow').modal('show');
//   })

//   if ($('.js-demoConfirmEmailWindow').length > 0) {
//     $('.js-demoConfirmEmailWindow').modal('show');
//   }

//   if ($('.js-demoConfirmAgeWindow').length > 0) {
//     $('.js-demoConfirmAgeWindow').modal('show');
//   }

//   if ($('.js-demoRestorePassSendEmailWindow').length > 0) {
//     $('.js-demoRestorePassSendEmailWindow').modal('show');

//     $(document).on('click', '.js-demoSendMail', function (e) {
//       e.preventDefault();
//       $(this).closest('.js-demoRestorePassSendEmailWindow').modal('hide');

//       if ($('.js-demoRestorePassNewPassWindow').length > 0) {
//         $('.js-demoRestorePassNewPassWindow').modal('show');
//       }
//     });
//   }
//   // --------------------- ~Modal Demo Scripts ---------------------

//   if ($('#confirmEmail').length > 0) {
//     $('#confirmEmail').modal('show');
//   }
//   $('.js-confirmProfileDeleting').on('click', function (e) {
//     e.preventDefault();
//     $('#editProfile').modal('hide');
//     scrollToTheTop();
//     $('#confirmProfileDeleting').modal('show');
//   })
//   $('.js-editProfile').on('click', function (e) {
//     e.preventDefault();
//     $('#editProfile').modal('show');
//   })
//   if ($('#register-popup').length > 0 && $('.register-popup-open').length > 0) {
//     $('.register-popup-open').on('click', function (e) {
//       e.preventDefault();
//       $('#register-popup').modal('show');
//     });
//     const getParameterByName = function (name) {
//       const urlParams = new URLSearchParams(window.location.search);

//       return urlParams.get(name);
//     }
//     if (getParameterByName('registration') !== null) {
//       $('#register-popup').modal('show');
//     }
//   }
//   if ($('.RestorePass').length > 0) {
//     $('.RestorePass').modal('show');
//   }

//   // Show Password/Hide Password
//   $('.js-toogleVisibility').on('click', function () {
//     let input = $(this).closest('.form-group').find('input');

//     if (input.attr('type') == 'text') {
//       input.attr('type', 'password');
//       $(this).addClass('Icon--showPass').removeClass('Icon--hidePass');
//     } else if (input.attr('type') == 'password') {
//       input.attr('type', 'text') == 'text';
//       $(this).addClass('Icon--hidePass').removeClass('Icon--showPass');
//     }
//   });

//   const showMessageInHeader = function (message, type) {
//     $('header').find('.InfoPanel').remove();
//     $('header').prepend(`
//       <div class="InfoPanel InfoPanel--${type || 'info'}">
//           <div class="f4f-page-container">
//               ${message}
//           </div>
//       </div>
//     `)
//   }

//   // AddAvatar
//   $('.js-demoAddAvatar').on('change', function () {
//     if (window.File && window.FileReader && window.FileList && window.Blob) {
//       if (this.files.length > 1 || this.files.length === 0) { return; }
//       const $input = $(this);
//       const file = this.files[0];

//       if (file.size > parseInt($input.attr('max')) || (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png')) {
//         showMessageInHeader('The file format/size is not supported. Please choose the file in PNG, JPG format up to 2MB', 'error');

//         return;
//       }
//       const $block = $input.closest('.Avatar__wrapper');
//       $block.addClass('loading');

//       const fd = new FormData();
//       fd.append('avatar', file);
//       $.ajax({
//         url: '/profile/upload-avatar',
//         data: fd,
//         processData: false,
//         contentType: false,
//         type: 'POST'
//       })
//           .done(function (response) {
//             if (response.success) {
//               document.querySelector('.Avatar__img').style.backgroundImage = 'url(' + response.avatarUrl + ')';
//               $input.closest('.Avatar').addClass('Avatar--hasImage');
//             } else {
//               showMessageInHeader(response.error || 'Error: Can not upload avatar.', 'error');
//             }
//             $block.removeClass('loading');
//           })
//           .fail(function () {
//             showMessageInHeader('Error: Can not upload avatar.', 'error');
//             $block.removeClass('loading');
//           });
//     } else {
//       showMessageInHeader('The File APIs are not fully supported in this browser!!!', 'error');
//     }
//   });

//   const sendForm = function ($form, $button, token) {
//     let data = $form.serializeArray();
//     if (token) {
//       data.push({'name': 'g-captcha-response', 'value': token});
//     }
//     $.ajax({
//       url: $form.attr('action'),
//       type: $form.attr('method') || 'POST',
//       dataType: 'JSON',
//       data: data,
//     })
//         .done(function (response) {
//           $button.prop('disabled', false);
//           $form.find('.is-invalid').removeClass('is-invalid');
//           $form.find('small.text-danger').remove();
//           if (response.closeModal) {
//             scrollToTheTop();
//             $form.closest('.modal').modal('hide');
//           }
//           if (response.message) {
//             showMessageInHeader(response.message.content, response.message.type);
//           }
//           if (response.reload) {
//             window.location.reload();
//           }
//           if (response.redirect) {
//             window.location.href = response.redirect;
//           }
//           if (response.reset) {
//             $form[0].reset();
//           }
//           if (response.resetCaptcha && typeof hcaptcha !== 'undefined' && hcaptcha) {
//             hcaptcha.reset();
//           }
//           if (response.replace) {
//             $(response.replace.from).html(response.replace.to);
//           }
//           if (response.ga && typeof ga !== 'undefined') {
//             ga('send', 'event', response.ga.category || 'form', response.ga.action, response.ga.label || undefined);
//           }
//           if (!response.success) {
//             if (response.errors) {
//               for (const fieldName in response.errors) {
//                 const $el = $form.find('[name="' + fieldName + '"]');
//                 const $block = $el.closest('.form-group');
//                 if (!$block.find('small.text-danger').length) {
//                   $el.addClass('is-invalid');
//                   $block.append(`<small class="error form-text text-danger">${response.errors[fieldName]}</small>`);
//                 }
//               }
//               scrollToTheTop();
//             }
//             if (response.error) {
//               $form.append(`<small class="error form-text text-danger">${response.error}</small>`);
//             }
//             if (!response.resetCaptcha && typeof hcaptcha !== 'undefined' && hcaptcha) {
//               hcaptcha.reset();
//             }
//           }
//         })
//         .fail(function () {
//           $button.prop('disabled', false);
//           $form.append(`<small class="error form-text text-danger">Server error. Please contact to administrator.</small>`);
//           if (typeof hcaptcha !== 'undefined' && hcaptcha) {
//             hcaptcha.reset();
//           }
//         });
//   }

//   const processForm = function ($form, $button) {
//       if ($button.prop('disabled')) {
//         return false;
//       }
//       $button.prop('disabled', true);
//       if (typeof executeReCaptcha === 'function' && typeof grecaptcha !== 'undefined' && grecaptcha) {
//         executeReCaptcha((token) => {
//           sendForm($form, $button, token);
//         });
//       } else {
//         sendForm($form, $button);
//       }
//   }

//   $.validator.addMethod("dateFormat", function(value, element) {
//         const validateDate = function (date, re, separator, iDays, iMonths, iYears) {
//           var check = false;
//           if (re.test(date)) {
//             var adata = date.split(separator);
//             var dd = parseInt(adata[iDays],10);
//             var mm = parseInt(adata[iMonths],10);
//             var yyyy = parseInt(adata[iYears],10);
//             var xdata = new Date(yyyy,mm-1,dd);
//             if ( ( xdata.getFullYear() === yyyy ) && ( xdata.getMonth () === mm - 1 ) && ( xdata.getDate() === dd ) ) {
//               check = true;
//             } else {
//               check = false;
//             }
//           } else {
//             check = false;
//           }

//           return check;
//         }

//         return this.optional(element)
//             || validateDate(value, /^\d{1,2}\.\d{1,2}\.\d{4}$/, '.', 0, 1, 2)
//             || validateDate(value, /^\d{4}\-\d{1,2}\-\d{1,2}$/, '-', 2, 1, 0);
//       },
//       "Wrong date format"
//   );

//   $.validator.setDefaults({
//     focusInvalid: true,
//     errorElement: 'small',
//     onfocusin: function(element, event) {
//       this.element(element);
//     },
//     highlight: function (element, errorClass, validClass) {
//       $(element).closest('.form-group').find('small.help-message').hide();
//     },
//     unhighlight: function (element, errorClass, validClass) {
//       $(element).closest('.form-group').find('small.help-message').show();
//     },
//     errorPlacement: function(error, element) {
//       if (!element.closest('.form-group').find('.error').length) {
//         error.addClass("form-text text-danger");
//         element.closest('.form-group').append(error);
//       }
//     },
//   });

//   $('button.js-validation-button').each(function () {
//     const $button = $(this);
//     const formId = $button.data('validate');
//     const $form = $(`#${formId}`);
//     const validation = $form.data('validation') || {};
//     const isAjax = $button.attr('type') !== 'submit';

//     const validator = $form.validate({
//       ...validation,
//       submitHandler: function () {
//         if (isAjax) {
//           processForm($form, $button);

//           return false;
//         }

//         return true;
//       },
//     });

//     $form.find('select.selectpicker').on('change', function () {
//       validator.element($(this));
//     });

//     $button.on('click', function () {
//       if ($form.valid()) {
//         return $form.submit();
//       }
//       validator.focusInvalid();

//       return false;
//     });
//   });

//   if ($('#copyPublicProfileLink').length) {
//     $('#copyPublicProfileLink').on('click', function () {
//       const textArea = document.createElement("textarea");
//       textArea.value = $(this).data('href');
//       document.getElementById('copyPublicProfileLink').appendChild(textArea);
//       textArea.select();
//       try {
//         console.log('Copying text command was ' + (document.execCommand('copy') ? 'successful' : 'unsuccessful'));
//       } catch (err) {
//         console.log('Oops, unable to copy');
//       }
//       textArea.remove();
//     });
//   }

//   $('input[data-dependency]').each(function () {
//     const $it = $(this), $dependent = $(`[name="${$it.data('dependency')}"]`);
//     $it.on('change', function () {
//       if ($it.prop('checked')) {
//         $dependent.closest('.form-group').show();
//       } else {
//         $dependent.closest('.form-group').hide();
//       }
//     });
//   });

//   if ($('select.select-with-links').length) {
//     $('select.select-with-links').on('change', function () {
//       const $select = $(this), $option = $select.find(':selected');

//       window.location.href = $option.data('link');
//     });
//   }

//   // Mac OS, Windows, iOS, Android, Other
//   const detectOS = function () {
//     const nAgt = navigator.userAgent;
//     const clientStrings = [
//       {s:'windows', r:/(Windows 10.0|Windows NT 10.0|Windows 8.1|Windows NT 6.3|Windows 8|Windows NT 6.2|Windows 7|Windows NT 6.1|Windows NT 6.0|Windows NT 5.2|Windows NT 5.1|Windows XP|Windows NT 5.0|Windows 2000|Win 9x 4.90|Windows ME|Windows 98|Win98|Windows 95|Win95|Windows_95|Windows NT 4.0|WinNT4.0|WinNT|Windows NT|Windows CE|Win16)/},
//       {s:'android', r:/Android/},
//       {s:'ios', r:/(iPhone|iPad|iPod)/},
//       {s:'mac-os', r:/(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh|Mac OS X)/},
//     ];
//     for (const id in clientStrings) {
//       const cs = clientStrings[id];
//       if (cs.r.test(nAgt)) {
//         return cs.s;
//       }
//     }

//     return null
//   }

//   $('.f4f-download-app-js').on('click', function (e) {
//     e.preventDefault();

//     const os = detectOS();
//     if (os) {
//       window.location.href = $(`#f4f-download-${os}-button`).attr('href');
//     } else {
//       $('#choose-your-platform').modal('show');
//     }
//   });

//   /*********** Load more button ************/
//   let canBeLoaded = true;
//   const bottomOffset = 400;

//   const $button = $('#load-more-news-button');
//   if ($button.length) {
//     $(window).scroll(function() {
//       if($(document).scrollTop() > ($(document).height() - $(window).height() - bottomOffset) && canBeLoaded === true) {
//         $.ajax({
//           url: $button.data('url'),
//           data: {
//             action: 'load_more',
//             query: $button.data('posts'),
//             page: $button.data('page'),
//           },
//           type: 'POST',
//           beforeSend: function(xhr) {
//             canBeLoaded = false;
//             $button.parent().show();
//           },
//           success: function(response) {
//             $button.parent().hide();
//             if(response) {
//               $button.parent().before(response);
//               $button.data('page', parseInt($button.data('page')) + 1);
//               if ($button.data('page') === $button.data('max-page')) {
//                 $button.remove();
//               } else {
//                 canBeLoaded = true;
//               }
//             }
//           }
//         });
//       }
//     });
//   }

//   /**
//    * Return a formated string from a date Object mimicking PHP's date() functionality
//    *
//    * format  string  "Y-m-d H:i:s" or similar PHP-style date format string
//    * date    mixed   Date Object, Datestring, or milliseconds
//    *
//    */
//   function dateFormat(format, date) {

//     if(!date || date === "") {
//       date = new Date();
//     } else if(typeof('date') !== 'object') {
//       date = new Date(date.replace(/-/g,"/")); // attempt to convert string to date object
//     }

//     var string = '',
//         mo = date.getMonth(),   // month (0-11)
//         m1 = mo+1,			    // month (1-12)
//         dow = date.getDay(),    // day of week (0-6)
//         d = date.getDate(),     // day of the month (1-31)
//         y = date.getFullYear(), // 1999 or 2003
//         h = date.getHours(),    // hour (0-23)
//         mi = date.getMinutes(), // minute (0-59)
//         s = date.getSeconds();  // seconds (0-59)

//     for (var i = 0, len = format.length; i < len; i++) {
//       switch(format[i])
//       {
//         case 'j': // Day of the month without leading zeros  (1 to 31)
//           string+= d;
//           break;

//         case 'd': // Day of the month, 2 digits with leading zeros (01 to 31)
//           string+= (d < 10) ? "0"+d : d;
//           break;

//         case 'l': // (lowercase 'L') A full textual representation of the day of the week
//           var days = Array("Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday");
//           string+= days[dow];
//           break;

//         case 'w': // Numeric representation of the day of the week (0=Sunday,1=Monday,...6=Saturday)
//           string+= dow;
//           break;

//         case 'D': // A textual representation of a day, three letters
//           days = Array("Sun","Mon","Tue","Wed","Thr","Fri","Sat");
//           string+= days[dow];
//           break;

//         case 'm': // Numeric representation of a month, with leading zeros (01 to 12)
//           string+= (m1 < 10) ? "0"+m1 : m1;
//           break;

//         case 'n': // Numeric representation of a month, without leading zeros (1 to 12)
//           string+= m1;
//           break;

//         case 'F': // A full textual representation of a month, such as January or March
//           var months = Array("January","February","March","April","May","June","July","August","September","October","November","December");
//           string+= months[mo];
//           break;

//         case 'M': // A short textual representation of a month, three letters (Jan - Dec)
//           months = Array("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec");
//           string+= months[mo];
//           break;

//         case 'Y': // A full numeric representation of a year, 4 digits (1999 OR 2003)
//           string+= y;
//           break;

//         case 'y': // A two digit representation of a year (99 OR 03)
//           string+= y.toString().slice(-2);
//           break;

//         case 'H': // 24-hour format of an hour with leading zeros (00 to 23)
//           string+= (h < 10) ? "0"+h : h;
//           break;

//         case 'g': // 12-hour format of an hour without leading zeros (1 to 12)
//           var hour = (h===0) ? 12 : h;
//           string+= (hour > 12) ? hour -12 : hour;
//           break;

//         case 'h': // 12-hour format of an hour with leading zeros (01 to 12)
//           hour = (h===0) ? 12 : h;
//           hour = ( hour > 12) ? hour -12 : hour;
//           string+= (hour < 10) ? "0"+hour : hour;
//           break;

//         case 'a': // Lowercase Ante meridiem and Post meridiem (am or pm)
//           string+= (h < 12) ? "am" : "pm";
//           break;

//         case 'i': // Minutes with leading zeros (00 to 59)
//           string+= (mi < 10) ? "0"+mi : mi;
//           break;

//         case 's': // Seconds, with leading zeros (00 to 59)
//           string+= (s < 10) ? "0"+s : s;
//           break;

//         case 'c': // ISO 8601 date (eg: 2012-11-20T18:05:54.944Z)
//           string+= date.toISOString();
//           break;

//         default:
//           string+= format[i];
//       }
//     }

//     return string;
//   }

//   if ($('.js-date-convert').length) {
//     $('.js-date-convert').each(function () {
//       const $this = $(this),
//         date = $this.data('realtime'),
//         formatForDate = $this.data('date-format'),
//         formatForTime = $this.data('time-format');

//       $this.text(dateFormat(formatForDate, date) + ' at ' + dateFormat(formatForTime, date));
//     });
//   }

//   ////// Cookie policies
//   const purecookieTitle = "Cookies."; // Title
//   const purecookieDesc = "By using this website, you automatically accept that we use cookies."; // Description
//   const purecookieLink = '';//'<a href="/cookie-policy/" target="_blank">What for?</a>'; // Cookiepolicy link
//   const purecookieButton = "Understood"; // Button text

//   function pureFadeIn(elem, display){
//     const el = document.getElementById(elem);
//     el.style.opacity = 0;
//     el.style.display = display || "block";

//     (function fade() {
//       let val = parseFloat(el.style.opacity);
//       if (!((val += .06) > 1)) {
//         el.style.opacity = val;
//         requestAnimationFrame(fade);
//       }
//     })();
//   }

//   function pureFadeOut(elem){
//     const el = document.getElementById(elem);
//     el.style.opacity = 1;

//     (function fade() {
//       if ((el.style.opacity -= .06) < 0) {
//         el.style.display = "none";
//       } else {
//         requestAnimationFrame(fade);
//       }
//     })();
//   }

//   function setCookie(name,value,days) {
//     let expires = "";
//     if (days) {
//       const date = new Date();
//       date.setTime(date.getTime() + (days*24*60*60*1000));
//       expires = "; expires=" + date.toUTCString();
//     }
//     document.cookie = name + "=" + (value || "")  + expires + "; path=/";
//   }

//   function getCookie(name) {
//     const nameEQ = name + "=";
//     const ca = document.cookie.split(';');
//     for(let i = 0;i < ca.length; i++) {
//       let c = ca[i];
//       while (c.charAt(0)==' ') c = c.substring(1,c.length);
//       if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
//     }
//     return null;
//   }

//   function eraseCookie(name) {
//     document.cookie = name+'=; Max-Age=-99999999;';
//   }

//   function purecookieDismiss() {
//     setCookie('cookiesConsent','1',7);
//     pureFadeOut("cookieConsentContainer");
//   }

//   function cookieConsent() {
//     if (!getCookie('cookiesConsent')) {
//       $('body').append(`<div class="cookieConsentContainer" id="cookieConsentContainer"><div class="cookieTitle"><p>${purecookieTitle}</p></div><div class="cookieDesc"><p>${purecookieDesc} ${purecookieLink}</p></div><div class="cookieButton" id="acceptCookiesPolicy"><span>${purecookieButton}</span></div></div>`);
//       pureFadeIn("cookieConsentContainer");

//       const el = document.getElementById("acceptCookiesPolicy");
//       el.addEventListener("click", purecookieDismiss, false);
//     }
//   }

//   window.onload = function() { cookieConsent(); };

//   /**************** Registration popup functionality */
//   const $countrySelects = $('.sign-up-user-country');
//   if ($countrySelects.length) {
//     $countrySelects.each(function () {
//       const $countrySelect = $(this);
//       if (!$countrySelect.hasClass('selectpicker')) {
//         return;
//       }
//       const $links = $countrySelect.closest('.main-links-block');
//       const changeAge = (country, age) => {
//         $links.find('a.btn').each(function () {
//           const url = new URL($(this).data('href'));
//           url.searchParams.append('country', country);
//           $(this).attr('href', url.toString());
//           $(this).find('span').text(age);
//         });
//         $links.find('a.btn').removeClass('hidden');
//       }
//       const ages = $countrySelect.data('table');
//       const defaultAge = $countrySelect.data('default');
//       $countrySelect.on('change', function () {
//         const val = $countrySelect.val();
//         console.log($countrySelect, val);
//         if (!val) {
//           $links.find('a.btn').addClass('hidden');
//         } else if (ages[val] !== undefined) {
//           changeAge(val, ages[val]);
//         } else {
//           changeAge(val, defaultAge);
//         }
//       });
//     });
//   }
// });
